export const disabledReceptors = [];
